<script setup lang="ts">
import type { LoadingSize } from '~/@types'

withDefaults(defineProps<{
  size?: LoadingSize
}>(), {
  size: 'small',
})
</script>

<template>
  <div
    class="i-tabler-loader animate-spin text-black"
    :class="{
      'text-4': size === 'small',
      'text-6': size === 'medium',
      'text-8': size === 'large',
    }"
  />
</template>
